/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_2_Task_Buy_PlantInputs */

const en_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy Your First Plant`)
};

const ar_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشتري نبتتك الأولى`)
};

const de_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaufen Sie Ihre erste Pflanze`)
};

const es_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compra tu primera planta`)
};

const fr_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achetez votre première plante`)
};

const it_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquista la tua prima pianta`)
};

const ja_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の植物を購入`)
};

const ko_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 식물 구입하기`)
};

const pt_br_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adquira sua primeira planta`)
};

const ru_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купите свое первое растение`)
};

const th_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซื้อต้นไม้ต้นแรกของคุณ`)
};

const tr_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk Bitkini Satın Al`)
};

const zh_cn_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买 1 棵新植物`)
};

const zh_tw_phase_2_task_buy_plant = /** @type {(inputs: Phase_2_Task_Buy_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購買 1 棵新植物`)
};

/**
* | output |
* | --- |
* | "Buy Your First Plant" |
*
* @param {Phase_2_Task_Buy_PlantInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const phase_2_task_buy_plant = /** @type {((inputs?: Phase_2_Task_Buy_PlantInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_2_Task_Buy_PlantInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phase_2_task_buy_plant(inputs)
	if (locale === "ar") return ar_phase_2_task_buy_plant(inputs)
	if (locale === "de") return de_phase_2_task_buy_plant(inputs)
	if (locale === "es") return es_phase_2_task_buy_plant(inputs)
	if (locale === "fr") return fr_phase_2_task_buy_plant(inputs)
	if (locale === "it") return it_phase_2_task_buy_plant(inputs)
	if (locale === "ja") return ja_phase_2_task_buy_plant(inputs)
	if (locale === "ko") return ko_phase_2_task_buy_plant(inputs)
	if (locale === "pt_br") return pt_br_phase_2_task_buy_plant(inputs)
	if (locale === "ru") return ru_phase_2_task_buy_plant(inputs)
	if (locale === "th") return th_phase_2_task_buy_plant(inputs)
	if (locale === "tr") return tr_phase_2_task_buy_plant(inputs)
	if (locale === "zh_cn") return zh_cn_phase_2_task_buy_plant(inputs)
	return zh_tw_phase_2_task_buy_plant(inputs)
});